module.exports = __webpack_public_path__ + "static/02-4404eb3121aa5cc4f432d7e5cae5fb98.jpg";